import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import rootReducer from "./rootReducer"; // Import your combined reducers

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["userDetails", "sidebarCount", "shipmentDetails"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check as it might cause issues with Redux Persist
    }),
});

const persistor = persistStore(store);

export { store, persistor };
